import React from 'react';

interface InvoicePaymentLinkProps {
  onClick: () => void;
  label?: string;
}

export const InvoicePaymentLink: React.FC<InvoicePaymentLinkProps> = ({
  onClick,
  label = 'Need to pay by invoice?'
}) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className="text-sm text-primary hover:text-primary-700 underline cursor-pointer bg-transparent border-none p-0"
    >
      {label}
    </button>
  );
};

export default InvoicePaymentLink;
